import { IHouse } from '../../../types/newbuilding/house';

export function sortByNames(prev: IHouse, next: IHouse) {
  return prev.houseName.localeCompare(next.houseName, 'kn', { numeric: true });
}
